import React from "react";
import { Link } from "react-router-dom";
import { Heart, Compass, HandHeart, Users, ShieldCheck, MessageCircle } from "lucide-react";

const VALUES = [
  { Icon: Heart, title: "Independence", text: "We build supports that grow capability, not dependency — participants lead." },
  { Icon: ShieldCheck, title: "Dignity", text: "Every interaction, every routine, every home — designed to respect the person." },
  { Icon: Compass, title: "Choice", text: "Real options and real voice. Participants shape who, what, when and how." },
  { Icon: HandHeart, title: "Person-centred care", text: "Plans and supports built around goals, values, culture and preferences." },
  { Icon: Users, title: "Collaboration", text: "We work alongside families, clinicians and coordinators — not around them." },
  { Icon: MessageCircle, title: "Honest communication", text: "Plain English, documented decisions, and a culture of feedback." },
];

export default function OurValuesPage() {
  return (
    <div data-testid="page-our-values">
      <section className="alpha-gradient-hero border-b border-[color:var(--alpha-line)]">
        <div className="alpha-container pt-14 pb-10">
          <div className="alpha-overline">Our values</div>
          <h1 className="mt-3 text-4xl sm:text-[52px] font-display font-medium tracking-tight leading-[1.05]">What we believe — and how we work.</h1>
          <p className="mt-5 max-w-2xl text-lg text-[color:var(--alpha-mute)]">Alpha Community Care was built around a handful of ideas we don't compromise on. They shape how we hire, how we match, how we respond, and how we build our homes.</p>
        </div>
      </section>

      <section className="alpha-section">
        <div className="alpha-container grid md:grid-cols-2 lg:grid-cols-3 gap-5">
          {VALUES.map((v, i) => (
            <div key={v.title} className={`alpha-card p-7 alpha-fade-up alpha-delay-${(i % 4) + 1}`} data-testid={`value-${v.title.toLowerCase().replace(/\s+/g, "-")}`}>
              <div className="w-12 h-12 rounded-xl bg-[color:var(--alpha-purple-50)] text-[color:var(--alpha-purple-700)] flex items-center justify-center">
                <v.Icon className="w-5 h-5" />
              </div>
              <h3 className="mt-5 font-display text-xl font-semibold">{v.title}</h3>
              <p className="text-sm text-[color:var(--alpha-mute)] mt-2 leading-relaxed">{v.text}</p>
            </div>
          ))}
        </div>

        <div className="alpha-container mt-14">
          <div className="relative overflow-hidden rounded-[28px] alpha-gradient p-10 sm:p-14 text-[color:var(--alpha-purple-50)]">
            <h3 className="font-display text-2xl sm:text-3xl font-medium">Values that translate into practice — not posters.</h3>
            <p className="mt-3 text-white/85 max-w-2xl">These principles are embedded in our governance, our supervision, our service planning, and our day-to-day delivery.</p>
            <div className="mt-6 flex flex-wrap gap-3">
              <Link to="/policies" className="bg-[color:var(--alpha-purple-50)] text-[color:var(--alpha-purple-800)] rounded-full px-6 py-3 font-semibold">Read our policies</Link>
              <Link to="/about" className="border border-white/60 rounded-full px-6 py-3 font-semibold text-white hover:bg-white/10">About Alpha</Link>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}
